module.exports = __webpack_public_path__ + "img/box5-04.5710c8f8.png";